var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expo-service-container"
  }, [_c('myImg', {
    attrs: {
      "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner_7.png"
    }
  }), _vm._v(" "), _c('my-tab', {
    attrs: {
      "tab-list": _vm.tabList,
      "activeIndex": _vm.activeIndex,
      "bread-title": _vm.breadTitle,
      "smallSize": ""
    },
    on: {
      "change": _vm.changeTab
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_wrap container"
  }, [(_vm.activeIndex == 0) ? _c('attact') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? _c('home-service') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 2) ? _c('exhibit-book') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 3) ? _c('exhibit-map') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 4) ? _c('exhibit-data') : _vm._e()], 1), _vm._v(" "), _c('page-footer')], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a7f92a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/exhibitor/index.vue
// module id = null
// module chunks = 